import React from "react";

const BottomDivider = ({ className }) => {
  return <div className={`bg-neutral-800 h-[1px] w-full ${className}`} />;
};

export default BottomDivider;
